import { defineMessages } from 'react-intl';

const messages = defineMessages({
  headerText: {
    id: 'X+94C1',
    defaultMessage:
      'Improve your customer experience while driving value for employees,  customers and your business. Take just a minute to fill out the ROI  estimator below and see for yourself how your telco can drive ROI across  customer service by partnering with IBM’s watsonx Assistant.',
  },
  input3: {
    id: 'ALHxfo',
    defaultMessage: 'Average agent admin time (minutes)',
  },
  reduceVolume: {
    id: 'YwH/hF',
    defaultMessage: 'Reduce call volume',
  },
  input2: {
    id: '1u/TAW',
    defaultMessage: 'Average contact/case handle time (minutes)',
  },
  input1: {
    id: 'wU9jxW',
    defaultMessage: 'Number of contacts / cases  (per year)',
  },
  title1: {
    id: 're0v3I',
    defaultMessage: 'Input the following values for your organization',
  },
  upBar1: {
    id: 'baoIB1',
    defaultMessage: '1. Reduce call volume',
  },
  title2: {
    id: '6uNQ4I',
    defaultMessage: 'Adjust the sliders based on your specific goals',
  },
  upBar2: {
    id: 'k9gQpK',
    defaultMessage: '2. Reduce handle times',
  },
  upBar3: {
    id: 'uOBidf',
    defaultMessage: '3. Reduce agent admin time',
  },
  resultsText: {
    id: 'GeyJTS',
    defaultMessage:
      'Potential productivity benefits that can be reinvested in your business to drive strategic initiatives and focus your agents on high value work.',
  },
  bar3: {
    id: 'Xqhken',
    defaultMessage: '% reduction in agent admin time',
  },
  bar1: {
    id: 'P0P+99',
    defaultMessage: '% contacts / cases deflected to chatbot',
  },
  reduceHandle: {
    id: 'wrxlP2',
    defaultMessage: 'Reduce handle times',
  },
  bar2: {
    id: 'wu0Zrx',
    defaultMessage: '% reduction in handle times',
  },
  reduceAdmin: {
    id: 'DwBqhp',
    defaultMessage: 'Reduce agent admin times',
  },
  resultsTitle: {
    id: 'AIvchG',
    defaultMessage: 'Estimated benefits summary',
  },
  savings: {
    id: 'NhFvTU',
    defaultMessage: 'Estimated annual savings',
  },
  headerTitle: {
    id: '/HIPvJ',
    defaultMessage: 'Estimate your benefits',
  },
});

export default messages;
